<script setup>
  import { ref, computed, watchEffect, useSlots } from 'vue';
  import Icon from '@/components/icons/Icon.vue';

  const emit = defineEmits(['accordian:toggle']);

  const props = defineProps({
    id: {
      type: [String, Number],
      required: true
    },
    collapsed: {
      type: Boolean,
      default: false
    },
  });

  const slots = useSlots();

  const collapsed = ref(props.collapsed);

  const handleClick = () => {
    collapsed.value = !collapsed.value;

    emit('accordian:toggle', collapsed.value);
  };

  const showHeaderContent = computed(() => !!slots['header-content']);

  watchEffect(() => {
    collapsed.value = props.collapsed;
  });

</script>

<template>
  <div 
    :id="props.id" 
    class="jwx-block"
    data-accordian="true"
    :data-collapsed="collapsed"
  >
    <div class="jwx-block__header">
      <div class="jwx-block__title-bar">
        <div class="jwx-block__title-content">
          <slot name="title-content"></slot>
        </div>
        <button 
          @click.prevent="handleClick"
          class="jwx-block__accordian-toggle"
          :aria-expanded="true"
          :aria-controls="`${props.id}-content`"
        >
          <Icon name="chevron-down" />
        </button>
      </div>
      <div
        v-if="showHeaderContent"
        class="jwx-block__header-content"
      >
        <slot name="header-content"></slot>
      </div>
    </div>
    <div 
      v-show="!collapsed"
      class="jwx-block__body" 
      :id="`${props.id}-content`"
    >
      <slot name="body"></slot>
    </div>
  </div>
</template>